import { Checkbox } from "@mcleod/components";
import { Api, StringUtil } from "@mcleod/core";
import { AutogenLayoutCarrierQualProfileValueSelectorPopup } from "./autogen/AutogenLayoutCarrierQualProfileValueSelectorPopup";

export class CarrierQualProfileValueSelectorPopup extends AutogenLayoutCarrierQualProfileValueSelectorPopup {
    private optionData: Map<String, String>;

    public initControls(savedValues: ISelectorFields, qualificationId: String) {
        this.optionData = new Map<String, String>();
        Api.search("lme/dispatch/brk-qual-detail", {multiselect:true, brk_qual_item_id:qualificationId,
            saved_values:savedValues})
            .then((response) => {
                    const availableDisplayValues = response?.data[0].display_values as String[];
                    const availableDbValues = response?.data[0].db_values as String[];

                let isChecked = false;
                if ((savedValues.idValues as String).substring(0,2) == ",,") {
                    isChecked = true;
                }
                this.add(new Checkbox(
                    {
                        id: `${"checkBoxValue|Blank"}`, caption: "<Blank>", fillHeight: false, maxHeight: 28,
                        checkSize: 28, valueChecked: "<Blank>", valueUnchecked: "", checked: isChecked, rowBreak: true
                    }
                ));
                this.optionData.set("<Blank>", "<Blank>");

                for (let i = 0; i < availableDbValues?.length; i++)
                {
                    isChecked = false;
                    if (savedValues.idValues.includes(availableDbValues[i] as string, 0)) {
                        isChecked = true;
                    }
                    this.add(new Checkbox(
                        {
                            id: `${"checkBoxValue|"}${availableDbValues[i] as string}`, caption: availableDisplayValues[i] as string, fillHeight: false, maxHeight: 28,
                            checkSize: 28, valueChecked: `${availableDbValues[i] as string}`, valueUnchecked: "", checked: isChecked, rowBreak: true
                        }
                    ));
                    this.optionData.set(availableDbValues[i] as String, availableDisplayValues[i] as String);
                }
            }
        );
    }

    public getResult():Object {
        const result = <ISelectorFields>{idValues: "", descriptions: ""};
        if (this.components.length > 0) {
            for (let i = 0; i < this.components.length; i++){
                const checkboxItem = this.components[i] as Checkbox;
                const itemResult = (checkboxItem.checked) ? checkboxItem.valueChecked : checkboxItem.valueUnchecked;
                result.idValues += (!StringUtil.isEmptyString(itemResult)) ? itemResult + "," : "";
                result.descriptions += (!StringUtil.isEmptyString(itemResult)) ? this.optionData.get(itemResult) + "\n" : "";
            }
            result.idValues = result.idValues.substring(0, result.idValues.length-1).trim();
        }
        return result;
     }
}

export class SelectorFields implements ISelectorFields {
    idValues: string;
    descriptions: string;
}

export interface ISelectorFields {
    idValues: string;
    descriptions: string;
}

